/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Pbs_Fb165Inputs */

const en__field_enum_pbs_fb165 = /** @type {(inputs: _Field_Enum_Pbs_Fb165Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F 16 Faculty of Medicine`)
};

const de__field_enum_pbs_fb165 = /** @type {(inputs: _Field_Enum_Pbs_Fb165Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FB 16 Medizin`)
};

/**
* | output |
* | --- |
* | "F 16 Faculty of Medicine" |
*
* @param {_Field_Enum_Pbs_Fb165Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_pbs_fb165 = /** @type {((inputs?: _Field_Enum_Pbs_Fb165Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Pbs_Fb165Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_pbs_fb165(inputs)
	return de__field_enum_pbs_fb165(inputs)
});
export { _field_enum_pbs_fb165 as "_field_enum_PBS_FB16" }